module.exports = __webpack_public_path__ + "media/bgm.2025867e.mp3";